import React from "react";
import PropTypes from "prop-types";
import { Table, Grid } from "semantic-ui-react";
import ResultItem from "./items/ResultItem";

const ResultTable = props => {
  const { name,sample, items, goToRef,comentarioAnti } = props;

  const colSpan = 4;
  
  const resultItems = items.map((item, index) => 
   
    (<ResultItem
      key={index}
      goToRef={goToRef}
      name={item.parametro}
      value={item.resultado}
      range={item.referencia}
      param_id={item.parametro_id}
      exam_code={item.codigo_examen}
      numeric={item.numerico}
      patientHistoric={props.patientHistoric}
      selectedPatientID={props.selectedPatientID}
      comentario={item.comentario || null} // 👈 nuevo
    />
  ));

  function titleCaseES(text) {
  if (!text) return "";
  return text
    .toLocaleLowerCase("es-ES")
    .replace(/\b\p{L}/gu, c => c.toLocaleUpperCase("es-ES"));
  }

  return (
    <Table
      compact="very"
      celled
      fixed
      //singleLine={true}
      structured
      size="small"
      //stackable
      style={{ borderTop: "2px solid #00ACC9", overflowX:"auto" }}
      //style={{ borderTop: "1px solid #3B85ED" }}
    >
      <colgroup>
        <col style={{ width:"38%"}}></col>
        <col style={{ width:"8%"}}></col>
        <col style={{ width:"39%"}}></col>
        <col style={{ width:"15%"}}></col>
      </colgroup>
      <Table.Header>
        {!!name && (
          <Table.Row>
            <Table.HeaderCell colSpan={colSpan} textAlign="center">
              {name}
            </Table.HeaderCell>
          </Table.Row>
        )}
        {!!sample && (
           <Table.Row>
              <Table.HeaderCell colSpan={colSpan}>
              <div className="header-flex">
                <div className="left">
                  <p>Origen de la muestra: {titleCaseES(sample)}</p>
                </div>

                {comentarioAnti && (
                  <div
                    className="right"
                    style={{color:"gray"}}
                    dangerouslySetInnerHTML={{ __html: comentarioAnti.comentario }}
                  />
                )}
              </div>
            </Table.HeaderCell>
          </Table.Row>
        )}  
        <Table.Row>
          <Table.HeaderCell>Parámetro</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" id="columnaGraficar">Graficar</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Resultado</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">V. Ref</Table.HeaderCell>
          {/*<Table.HeaderCell width={1} textAlign="center">Comentario</Table.HeaderCell>*/}
        </Table.Row>
      </Table.Header>
      <Table.Body>{resultItems}</Table.Body>
    </Table>
  );
};

ResultTable.propTypes = {
  items: PropTypes.array,
  patientHistoric: PropTypes.func.isRequired,
};

export default ResultTable;
